import React from 'react'
import Form from 'react-bootstrap/Form'

import SectionHeader from '@components/SectionHeader'
import FormRichText from '@app/components/ke-forms/FormRichText'

const { I18n } = window

interface EventDetailsSectionProps {
  onAboutChangeEvent(e: React.ChangeEvent<HTMLInputElement>): void
  onRegistrationChangeEvent(e: React.ChangeEvent<HTMLInputElement>): void
  aboutThisEvent: string
  registrationConfirmationMessage: string
}

const EventDetailsSection: React.FC<EventDetailsSectionProps> = ({
  onAboutChangeEvent,
  onRegistrationChangeEvent,
  aboutThisEvent,
  registrationConfirmationMessage,
}) => (
  <fieldset>
    <SectionHeader text={I18n.t('views.events.event_details')} />

    <Form.Group controlId="event_description">
      <Form.Label>{I18n.t('views.events.about')}</Form.Label>
      <FormRichText
        required
        id="event_description"
        name="program_event[description]"
        value={aboutThisEvent}
        onChange={onAboutChangeEvent}
      />
    </Form.Group>

    <Form.Group controlId="reg_confirmation_message">
      <Form.Label>{I18n.t('views.events.registration_confirmation_message')}</Form.Label>
      <FormRichText
        required
        id="event_registration_confirmation_message"
        name="program_event[registration_confirmation_message]"
        onChange={onRegistrationChangeEvent}
        value={registrationConfirmationMessage}
      />
    </Form.Group>
  </fieldset>
)

export default EventDetailsSection